import React from 'react';
import Modal from "../modal/modal";
import styles from './styles.scss'

const UpdateGuideModal = ({ onClose, content, onConfirm }) => {
    return (
        <Modal
            title="提示"
            onClose={onClose}
        >
            <div>
                <p>{content}</p>
            </div>
            <div className={styles.btn}>
                <span onClick={onClose}>取消</span>
                <span onClick={onConfirm}>确定</span>
            </div>
        </Modal>

    );
}

export default UpdateGuideModal;
